import { render, staticRenderFns } from "./WorkerAssignmentsByWI.vue?vue&type=template&id=eca01e72"
import script from "./WorkerAssignmentsByWI.vue?vue&type=script&lang=js"
export * from "./WorkerAssignmentsByWI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports